// import ikan_background from '../img/ikan_background.PNG';
import ikan_background from '../img/bg-1.png';
import Chatbot from './Chatbot';

const Landing = () => {
  return (
    <div
      className="relative w-full h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${ikan_background})` }}
    >
      <Chatbot />
      </div>
    
  );
};

export default Landing;
